<template>
 <paper>
  <div class="tenderTemplate">
    <div class="tenderTemplate-head">
      <div class="head-left">
        <el-input class="el-input" v-model="editorInfo.templateCode" placeholder="模板编号" size="mini" clearable></el-input>
        <el-input class="el-input" v-model="editorInfo.templateName" placeholder="模板名称" size="mini" clearable></el-input>
        <mSelect class="el-input" :optionNum="'BID_TEMPLATE_STATUS'" :value="editorInfo.templateType" :placeholder="'模板状态'" :filterable="true" @input="getTemplateType"></mSelect>
        <el-input class="el-input" v-model="editorInfo.templateDesc" placeholder="计费规则模板" size="mini" clearable></el-input>
        <mSelect class="el-input" :optionNum="'SRM_YES_NO'" :value="editorInfo.priceBarb" :placeholder="'是否防倒挂'" :filterable="true" @input="getPriceBarb"></mSelect>
        <span v-has="'02020004'"><el-button type="primary" size="mini" class="paddingleft bigData-btn-search" @click="seachFn">查 询</el-button></span>
      </div>
      <div class="header-button">
        <el-tooltip effect="dark" content="新增" placement="bottom" v-has="'02020001'">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addTemplate"></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="刷新" placement="bottom" class="tooltip" v-has="'02020002'">
          <el-button class="bigData-btn-refresh" icon="el-icon-refresh" size="mini" @click="refreshFn"></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="列配置" placement="bottom" class="tooltip" v-has="'02020003'">
          <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table
      :height="50"
      v-loading="loading"
      :data="announceList"
      class="list-table"
      border
      ref="table"
      style="width: 100%"
      @cell-dblclick="dbEnterDetail"
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column
        v-for="(item, index) in columnsList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        align="center"
        :min-width="item.width?item.width : ''"
      >
        <template slot-scope="scope">
          <div v-if="scope.column.label === '模版编号'">
            <span class="template-code" @click="dbEnterDetail(scope.row)">{{scope.row.templateCode}}</span>
          </div>
          <div v-else-if="scope.column.label === '模版名称'">
            <span>{{scope.row.templateName}}</span>
          </div>
          <div v-else-if="scope.column.label === '模版状态'">
           <span>{{conversionData(scope.row.status)}}</span>
          </div>
          <div v-else-if="scope.column.label === '是否防倒挂'">
           <span>{{scope.row._priceBarb}}</span>
          </div>
          <div v-else-if="scope.column.label === '计费规则模版编码'">
            <span>{{scope.row.calRuleCode}}</span>
          </div>
          <div v-else-if="scope.column.label === '计费规则模版名称'">
            <span>{{scope.row.calRuleName}}</span>
          </div>
              <div v-else-if="scope.column.label === '创建人'">
            <span>{{scope.row.createUserName}}</span>
          </div>
              <div v-else-if="scope.column.label === '创建日期'">
            <span>{{scope.row.createTime}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作" width="210" align="center" fixed="right">
        <template slot-scope="scope">
          <span class="btn-span" v-has="'02020005'">
              <el-button v-if="scope.row.status==='3'||scope.row.status==='4'||scope.row.status==='6'" size="mini" type="text" @click="deleteRow(scope.row.id)">删除</el-button></span>
          <span class="btn-span" v-has="'02020006'"><el-button v-if="scope.row.status==='1'" size="mini" type="text" @click="stopUsing(scope.row.id,scope.row.version)">停用</el-button></span>
          <span class="btn-span" v-has="'02020008'">
            <el-button v-if="scope.row.status==='2'||scope.row.status==='3'||scope.row.status==='4'||scope.row.status==='5'||scope.row.status==='6'"
            size="mini" type="text" @click="startUsing(scope.row)">{{scope.row.status==='2'||scope.row.status==='3'?'启用':'MIP提交'}}</el-button></span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      slot="footer"
      class="text-right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="editorInfo.pageNo"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="editorInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"></el-pagination>
    <el-dialog :visible.sync="showModal" title="列配置">
      <configuration
        :checkedList="checkedList"
        :selectAllColumns="selectAllColumns"
        ref="dialog"
        @getTableConfigList="getTableConfigList"
        @tableConfigClose="tableConfigClose"
        :columnNum="columnNum"
      ></configuration>
    </el-dialog>
  </div>
   </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import { mapGetters } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';
import configuration from '@/components/otpPanel/configuration-list';
import mSelect from '@/components/lots/otpSelect2';
import { templateList, templateModify, templateDelete, templateDetail, approvalTemplate } from '../../../../lsrm/api/tenderTemp.js';
import { getList } from '../../../../lsrm/api/annoMana.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    name: 'tendertemplate',
    components: { paper, configuration, mSelect },
    data() {
        return {
            dictData: {}, // 数字字典
            resourceCode: '',
            editorInfo: {
                templateCode: '',
                templateName: '',
                status: '',
                templatedesc: '',
                priceBarb:'',//是否防倒挂
                pageNo: 1,
                pageSize: 10
            },
            announceList: [],
            loading: false,
            columnNum: 100,
            showModal: false,
            checkedList: '',
            selectAllColumns: [
                {
                    prop: 'templateCode',
                    label: '模版编号',
                    width: '180'
                },
                {
                    prop: 'templateName',
                    label: '模版名称',
                    width: '280'
                },
                {
                    prop: 'status',
                    label: '模版状态',
                    width: '180'
                },
                {
                    prop: 'priceBarb',
                    label: '是否防倒挂',
                    width: '180'
                },
                {
                    prop: 'calRuleCode',
                    label: '计费规则模版编码',
                    width: '180'
                },
                {
                    prop: 'calRuleName',
                    label: '计费规则模版名称',
                    width: '180'
                },
                {
                    prop: 'createUserName',
                    label: '创建人',
                    width: '100'
                },
                {
                    prop: 'createTime',
                    label: '创建日期',
                    width: '150'
                }
            ],
            columnsList: [
                {
                    prop: 'templateCode',
                    label: '模版编号',
                    width: '180'
                },
                {
                    prop: 'templateName',
                    label: '模版名称',
                    width: '280'
                },
                {
                    prop: 'status',
                    label: '模版状态',
                    width: '180'
                },
                {
                    prop: 'priceBarb',
                    label: '是否防倒挂',
                    width: '180'
                },
                {
                    prop: 'calRuleCode',
                    label: '计费规则模版编码',
                    width: '180'
                },
                {
                    prop: 'calRuleName',
                    label: '计费规则模版名称',
                    width: '180'
                },
                {
                    prop: 'createUserName',
                    label: '创建人',
                    width: '100'
                },
                {
                    prop: 'createTime',
                    label: '创建日期',
                    width: '150'
                }
            ],
            totalCount: 0,
            TodoPath: ''
        };
    },
    mounted() {
        // 数字字典转换
        // 是否防倒挂 数据字典 SRM_YES_NO
        dictWithUrl('BID_TEMPLATE_STATUS,SRM_YES_NO').then(res => {
            this.dictData = res.data;
            this.loadData(this.editorInfo);
        });
        this.setConfigColumn();
    },
    computed: {
        ...mapGetters(['menus', 'currentTenant', 'applicationCode'])
    },
    methods: {
        //是否防倒挂
        getPriceBarb(val) {this.editorInfo.priceBarb = val; },
        refreshFn() {
            this.loadData(this.editorInfo);
        },
        setConfigColumn() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
            const pramas = {
                moduleCode: this.resourceCode,
                subjectType: 'tenderList'
            };
            getList.get(pramas).then(res => {
                if (res.data && res.data.configNameCn) {
                    const datas = res.data.configNameCn.split(',');
                    const columnsList = [];
                    datas.map(title => {
                        this.selectAllColumns.map(data => {
                            if (data.label === title) {
                                columnsList.push(data);
                            }
                        });
                    });
                    this.columnsList = columnsList;
                    const arr = [];
                    this.columnsList.forEach(el => {
                        arr.push(el.label);
                    });
                    this.checkedList = arr.join(',');
                }
            });
        },
        deepMenuFor(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path || (childrens[i].frontUrl === '/index' && this.$route.path === '/')) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.deepMenuFor(childrens);
                }
            }
        },
        conversionData(val) {
            val = this.dictData.BID_TEMPLATE_STATUS[val];
            return val;
        },
        conversionAllData(list) {
            for (const item of list) {
                // 是否防倒挂 priceBarb 数据字典 SRM_YES_NO
                item._priceBarb = this.dictData.SRM_YES_NO[item.priceBarb];
            }
           
            return list;
        },
        loadData(serachObj) {
            templateList(serachObj).then(res => {
                if (res.code === '0') {
                    this.announceList = this.conversionAllData(res.data.list);
                    this.totalCount = res.data.totalCount;
                }
            });

            const arr = [];
            this.columnsList.forEach(el => {
                arr.push(el.label);
            });
            this.checkedList = arr.join(',');
        },
        colDispose() {
            this.showModal = true;
        },
        handleSizeChange(val) {
            this.editorInfo.pageSize = val;
            this.loadData(this.editorInfo);
        },
        handleCurrentChange(val) {
            this.editorInfo.pageNo = val;
            this.loadData(this.editorInfo);
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                configName: tabelConfigName,
                configNameCn: tabelConfigList,
                subjectType: 'tenderList',
                moduleCode: this.resourceCode
            };
            getList.post(pramas).then(() => {});
            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        },
        tableConfigClose() {
            this.showModal = false;
        },
        addTemplate() {
            bigDataLog.sendDetailMessageByKey('bigData-btn-add');
            this.$router.push({ name: 'templatedetails' });
        },
        getTemplateType(val) {
            this.editorInfo.status = val;
        },
        // 双击列表
        dbEnterDetail(row) {
            this.$router.push({
                name: 'templatedetails',
                query: { templateCode: row.templateCode, id: row.id, isMoreRule: row.isMoreRule }
            });
        },
        // 查询
        async seachFn() {
            this.editorInfo.pageNo = 1;
            this.loadData(this.editorInfo);
        },
        // 删除
        deleteRow(id) {
            this.$confirm('是否确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                const res = await templateDelete(id);
                if (res && res.code === '0') {
                    this.loadData(this.editorInfo);
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                }
            }).catch(() => {});
        },
        // 启用
        async startUsing(row) {
            let startCity = false;
            let endCity = false;
            // let lineCode = false;
            let startArea = false;
            let endArea = false;
            const res = await templateDetail({ templateCode: row.templateCode });
            if (res && res.code === '0') {
                res.data.forEach(item => {
                    if (item.fieldName === '起始地(市)') { startCity = true; }
                    if (item.fieldName === '起始地(区)') { startArea = true; }
                    if (item.fieldName === '目的地(市)') { endCity = true; }
                    // if (item.fieldName === '线路编码') { lineCode = true; }
                    if (item.fieldName === '目的地(区)') { endArea = true; }
                });
            }
            // 运输类型，校验线路编码不能为空
            // if (row.businessType === '3' && !lineCode) {
            //     this.$message.warning('业务类型为运输类型，必须要有线路编码这个字段!');
            //     return;
            // }
            if ((row.lineType === '干线' || row.lineType === '支线' || row.lineType === '配送') && (!startCity || !endCity)) {
                this.$message.warning('线路类型为干/支线/配送,必须要有、起始地(市)、目的地(市)这2个字段');
                return;
            }
            if (row.lineType === '揽收' && (!startArea || !endArea || !startCity || !endCity)) {
                this.$message.warning('线路类型为揽收,必须要有、起始地(市)、目的地(市)、起始地(区)、目的地(区)这4个字段');
                return;
            }
            //  else if (row.lineType === '市配') {
            //     if (!startCity || !endCity || !startArea || !endArea) {
            //         this.$message.warning('线路类型为市配,必须要有)、起始地(市)、起始地(区)、目的地(市)、目的地(区)这4个字段');
            //         return;
            //     }
            // }
            if (row.status === '2') { // 禁用状态直接启用，不走mip流程
                await templateModify(row.id, { status: '1', version: row.version });
                this.loadData(this.editorInfo);
            } else { this.iFlow(row); }
        },
        async iFlow(row) {
            let strUrl = '';
            strUrl = `${location.origin}${location.pathname}#/templatedetails?templateCode=${row.templateCode}&id=${row.id}`;
            const params = {
                tenantCode: this.currentTenant.tenantCode,
                appCode: this.applicationCode,
                fdTemplateCode: 'srm_template_bpm',
                loginName: this.$store.getters.user.userCode,
                formParam: {
                    subject: row.templateCode + '_' + row.templateName + '_招标模板审批_' + this.$store.getters.user.userName,
                    formInstanceId: row.templateCode,
                    fdUrl: strUrl
                }
            };
            const approvalRes = await approvalTemplate(params);
            if (approvalRes && approvalRes.code === '0') {
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        processId: approvalRes.data.fdId,
                        formInstanceId: row.templateCode,
                        path: 'tendertemplate'
                    }
                });
            }
        },
        // 停用
        async stopUsing(id, version) {
            await templateModify(id, { status: '2', version });
            this.loadData(this.editorInfo);
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (!from.name) { vm.TodoPath = from.name; }
        });
    },
    watch: {
        async TodoPath(val) {
            if (!val && this.$route.query.formInstanceId) {
                const res = await templateList({ templateCode: this.$route.query.formInstanceId });
                if (res && res.data.list.length !== 0) {
                    this.iFlow(res.data.list[0]);
                }
            }
        }
    }
};
</script>
<style lang="less">
.tenderTemplate {
  .tenderTemplate-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px ;
    .head-left {
      display: flex;
    }
    .el-input{margin-right: 10px;}
  }
  .template-code {
    color: #00bcbf;
    cursor: pointer;
  }
  .table-point {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    margin-right: 10px;
  }
  .header-button {
    display: flex;
    align-items: flex-end;
    .tooltip {
      margin-left: 10px;
    }
  }
    .el-table {
    min-height: calc(~"100vh - 190px");
    max-height: calc(~"100vh - 190px");
  }
  .btn-span :nth-of-type(odd){margin-right:5px;}
  .el-table--border {
  border: 1px solid #ebeef5;
}
}

</style>